module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (144).0c1c023e.jpg";